import { Container } from 'react-bootstrap';
import '../../css/Content.css';
import 'bootstrap/dist/css/bootstrap.min.css'

export const Page26 = () => {




  return (
    <>      
      <section>   

      <div className='container'>

        <div style={{ paddinBottom: "80px"}}>  

          <div style={{height: '85vh', display: 'flex', alignItems: 'center', color: '#ffffff'}}>
            <div>
              <p>
                Chegamos ao final do Módulo 1 do curso de Procedimento de Gerenciamento de Mudança (MOC).
              </p>
              <p>
                Ao longo dessa jornada, foram apresentados os conceitos fundamentais do MOC, incluindo o que caracteriza uma mudança, os papéis e responsabilidades envolvidos e o fluxo do processo, da solicitação ao encerramento.
              </p>
              <p>
                Esses conceitos sustentam a aplicação segura do Gerenciamento de Mudanças. 
              </p>     
              <p>
                Na sequência, o curso avança para o módulo prático, com situações reais e exemplos do dia a dia para aplicar o MOC na prática.
              </p>
              <p><strong>Até breve!</strong></p>              
            </div>
          </div>         

        </div>
        
      </div>

      </section>
    </>
  );
};

export default Page26;